import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { syncNetherlandsFixturesCurrentYearAsync, } from './footballThunk';
const initialState = {
    status: APIStatus.IDLE,
    leagues: [],
    lastLeaguesSync: null,
    lastFixturesCurrentYearSync: null
};
export const footballSlice = createSlice({
    name: 'football',
    initialState,
    reducers: {
        clearLeagues: (state) => {
            state.leagues = [];
        },
        clearFixturesCurrentYear: (state) => {
        },
        clearSyncResults: (state) => {
            state.lastLeaguesSync = null;
            state.lastFixturesCurrentYearSync = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(syncNetherlandsFixturesCurrentYearAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(syncNetherlandsFixturesCurrentYearAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.apiError = undefined;
        })
            .addCase(syncNetherlandsFixturesCurrentYearAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { clearLeagues, clearFixturesCurrentYear, clearSyncResults } = footballSlice.actions;
export const selectFootballState = (state) => state.football;
export const selectFootballLeagues = (state) => state.football.leagues;
export const selectFootballLastLeaguesSync = (state) => state.football.lastLeaguesSync;
export const selectFootballLastFixturesCurrentYearSync = (state) => state.football.lastFixturesCurrentYearSync;
export const selectFootballStatus = (state) => state.football.status;
export const selectFootballError = (state) => state.football.apiError;
export default footballSlice.reducer;
